export const environment = { production: true, url: 'https://api.universalcoins.net/api/' };
